import React from "react";
import Icons from "../../../../Config/Images";
import "./styles.css";

const ConfirmationPopup = ({ onClose, onYesClick, title }) => {
  return (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal-content">
        <img src={Icons.trashIcon} alt="confirmation Icon" />
        <h4 className="confirmation-modal-title">{title}</h4>

        <div className="confirmation-modal-buttons">
          <button onClick={onClose} className="confirmation-no-button">
            No
          </button>
          <button onClick={onYesClick} className="confirmation-yes-button">
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
